import { render, staticRenderFns } from "./PaulMariekeFestivalMegamix.vue?vue&type=template&id=1a94b34c&scoped=true&"
import script from "./PaulMariekeFestivalMegamix.vue?vue&type=script&lang=js&"
export * from "./PaulMariekeFestivalMegamix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a94b34c",
  null
  
)

export default component.exports